import PropTypes from "prop-types"
import React, { useState } from "react"
import { Col, FormGroup, Input, Label } from "reactstrap"

const FormInputArea = props => {
  const { attribute, description, value, setValue, changeHandeler, required, minLength, maxLength, rows, disabled, placeholder } = props

  const [touched, setTouched] = useState(false)

  const changeHandelerInput = (valor, elementId, validacao) => {
    if(validacao !== null && validacao !== undefined) {
      if(validacao === false) {
        document.getElementById(elementId).style.display = 'block'
      } else {
        document.getElementById(elementId).style.display = 'none'
      }
    } else {
      if (valor !== "" && valor !== undefined && valor !== null) {
        document.getElementById(elementId).style.display = 'none'
      } else {
        document.getElementById(elementId).style.display = 'block'
      }
    }
  }

  return (
    <React.Fragment>
      <FormGroup className="mb-4" row>
        <Label htmlFor={ attribute + "-text" } className="col-form-label col-lg-2">
          { description }
        </Label>
        <Col lg="10">
          <Input
            id={ attribute + "-text"}
            name={ attribute + "-text"}
            type="textarea"
            className={ "form-control " + (touched && required && !value? "is-invalid" : "") }
            value={ value }
            onChange={ e => {
              if(!touched) setTouched(true)
              setValue(e.target.value)

              if(required) {
                if(changeHandeler !== undefined) {
                  changeHandeler(e.target.value, `validate-required-${ attribute }-text`)
                } else {
                  changeHandelerInput(e.target.value, `validate-required-${ attribute }-text`)
                }
              }
            } }
            placeholder= { placeholder ? placeholder : `Digite a(o) ${description}`}
            required={ required }
            minLength={ minLength }
            maxLength={ maxLength }
            rows={ rows }
            disabled={ disabled }
          />
          { required &&
            <div className={ value ? "" : "invalid-tooltip" }
                 name="validate-required" id={ `validate-required-${ attribute }-text` }>
              { value ? "" : `${ description } é obrigatório(a)`}
            </div>
          }
        </Col>
      </FormGroup>
    </React.Fragment>
  )
}

FormInputArea.propTypes = {
  attribute: PropTypes.string,
  description: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  value: PropTypes.any,
  setValue: PropTypes.func,
  changeHandeler: PropTypes.func,
  minLength: PropTypes.number,
  maxLength: PropTypes.number,
  rows: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

export default FormInputArea
